import React from "react";
import { Link } from "react-router-dom";
import { useSeo } from "../../site/ui";

export default function LaonaNotFound() {
  useSeo({ title: "페이지를 찾을 수 없습니다 — LaonaBot" });
  return (
    <section className="lb-section lb-section--top">
      <div className="lb-wrap">
        <div className="lb-empty lb-empty--box">
          <b>페이지를 찾을 수 없습니다</b>
          <p>주소가 바뀌었거나 없는 페이지입니다. <Link to="/laonabot">라오나봇 소개</Link>로 돌아가 주세요.</p>
        </div>
      </div>
    </section>
  );
}
